import { ButtonStyleCheckbox, ButtonStyleCheckboxGroup, CheckboxGroup } from '@uplift/ui-v2';
import { useQuery } from '@tanstack/react-query';
import { getSupportedAgeGroups } from '@uplift/api';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';

export type ClientAgesFormProps = {
  enableButtonStyle?: boolean;
};

export const ClientAgesForm: React.VFC<ClientAgesFormProps> = (props) => {
  const { data: supportedAgeGroups = [], isInitialLoading: loading } = useQuery(PROFILE_ROW_QUERY_KEYS.supportedAgeGroups, async () => {
    const response = await getSupportedAgeGroups();

    return response.ages;
  });

  if (props.enableButtonStyle) {
    return (
      <div>
        <ButtonStyleCheckboxGroup name="supportedAgeGroups">
          {supportedAgeGroups.map(({ name, id }) => (
            <ButtonStyleCheckbox value={id} key={id} label={name} />
          ))}
        </ButtonStyleCheckboxGroup>
      </div>
    );
  }

  return (
    <div>
      <CheckboxGroup
        name="supportedAgeGroups"
        options={supportedAgeGroups.map(({ name, id }) => ({ label: name, value: id }))}
        loading={loading}
      />
    </div>
  );
};
